// Removes html tags from richText, except <mark> tag for highlighting
export const plainText = (richText: string | null) => {
  if (!richText) return ''

  const helperEl = document.createElement('div')
  helperEl.innerHTML = richText.replace(/<(\/?mark)>/g, '%%$1%%')

  return helperEl.innerText.replace(/%%(\/?mark)%%/g, '<$1>')
}